import React from "react";

export type FeatureItem =
  | {
      /** Başlık */
      title: string;
      /** Açıklama */
      description: string;
      /** React öğesi (SVG, ikon bileşeni vs.) veya string (img src) */
      icon: React.ReactNode | string;
      /** icon string ise gerekir */
      alt?: string;
    };

export type FeaturesRowProps = {
  /** Kart listesi */
  items: FeatureItem[];
  /** Tema rengi (ikon rengi) */
  accentColor?: string; // default #2ba87a

  /** Başlık rengi / metin rengi isterseniz */
  textColor?: string; // default #2b2b2b
  /** Açıklama rengi */
  mutedColor?: string; // default #666
};

const FeaturesRow: React.FC<FeaturesRowProps> = ({
  items,
  accentColor = "#2ba87a",
  textColor = "#2b2b2b",
  mutedColor = "#666",
}) => {
  return (
    <section
      className="features-row"
      style={
        {
          // SCSS değişkenlerine köprü
          "--fr-green": accentColor,
          "--fr-text": textColor,
          "--fr-muted": mutedColor,
        } as React.CSSProperties
      }
    >
      <div className="fr-container">
        <div className="fr-grid">
          {items.map((it, idx) => (
            <article className="fr-item" key={idx}>
              <div className="fr-ico" aria-hidden={typeof it.icon !== "string"}>
                {/* ReactNode (SVG/ikon) ya da string (img) */}
                {typeof it.icon === "string" ? (
                  <img src={it.icon} alt={it.alt ?? ""} />
                ) : (
                  it.icon
                )}
              </div>
              <div className="fr-body">
                <h3 className="fr-title">{it.title}</h3>
                <p className="fr-desc">{it.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesRow;
